import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import SMFacilitiesListItem from '../SMFacilitiesListItem';
import SMFacilitiesListItemExpanded from '../SMFacilitiesListItemExpanded';

const propTypes = {
  activeFacility: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  facilities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  onItemHover: PropTypes.func,
  multiLocale: PropTypes.bool,
  expandedItems: PropTypes.bool,
  moveInPath: PropTypes.string,
  selectedUnitSize: PropTypes.string,
  selectedAmenities: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
  activeFacility: undefined,
  multiLocale: false,
  onItemHover: undefined,
  expandedItems: false,
  moveInPath: undefined,
  selectedUnitSize: undefined,
  selectedAmenities: [],
};

const SMFacilitiesList = ({
  activeFacility,
  facilities,
  multiLocale,
  onItemHover,
  expandedItems,
  moveInPath,
  selectedUnitSize,
  selectedAmenities,
  theme,
}) => {
  const facilitiesBeforeFeatures = facilities.slice(0, 2);
  const facilitiesAfterFeatures = facilities.slice(2);

  const item = indexPad => (facility, index) => {
    const { id: facilityId } = facility;

    return expandedItems ? (
      <SMFacilitiesListItemExpanded
        key={facilityId}
        active={activeFacility && facilityId === activeFacility.id}
        index={index + indexPad}
        onHover={onItemHover}
        facility={facility}
        multiLocale={multiLocale}
        moveInPath={moveInPath}
        selectedUnitSize={selectedUnitSize}
        selectedAmenities={selectedAmenities}
        theme={theme}
      />
    ) : (
      <SMFacilitiesListItem
        key={facilityId}
        active={activeFacility && facilityId === activeFacility.id}
        index={index + indexPad}
        onHover={onItemHover}
        facility={facility}
        multiLocale={multiLocale}
      />
    );
  };

  return (
    <ul className="flex gap-4 m-0 p-0 flex-col">
      {facilitiesBeforeFeatures.map(item(0))}
      {facilitiesAfterFeatures.map(item(2))}
    </ul>
  );
};

SMFacilitiesList.propTypes = propTypes;
SMFacilitiesList.defaultProps = defaultProps;

SMFacilitiesList.fragments = {
  facility: gql`
    fragment SMFacilitiesListFacility on Facility {
      id
      ...SMFacilitiesListItemFacility
      ...SMFacilitiesListItemExpandedFacility
    }

    ${SMFacilitiesListItem.fragments.facility}
    ${SMFacilitiesListItemExpanded.fragments.facility}
  `,
};

export default SMFacilitiesList;
